module.exports = __webpack_public_path__ + "img/shenhe.ea880d4d.png";